import CommonIcon from 'CommonIcon'
import React from 'react'
import { countryShortNameToString } from 'utils'

interface Props {
  companyName?: string
  companyId?: string
  countryId: string
  countryName?: string
}

const CompanyDelayed = ({ companyName, companyId, countryId, countryName = '' }: Props) => (
  <div className="completeness-details-table-company">
    <CommonIcon name={countryShortNameToString(companyId || countryId)} />
    {companyName}
    {countryName}
  </div>
)

export default CompanyDelayed
